import React from "react";
import { formatPhoneNumber } from "../../utils/format";

const MemberAuthTab = ({
  loading,
  waitingMembers,
  countdown,
  fetchWaitingMembers,
  setSelectedMember,
  setShowModal,
  formatDate,
}) => {
  const tableHeaderStyle = {
    padding: "16px 12px",
    textAlign: "left",
    fontWeight: "600",
    color: "#374151",
    borderBottom: "2px solid #e2e8f0",
  };

  const tableCellStyle = {
    padding: "16px 12px",
    borderBottom: "1px solid #e2e8f0",
    color: "#4b5563",
  };

  return (
    <div
      style={{
        background: "white",
        borderRadius: "12px",
        padding: "30px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "24px",
            color: "#333",
            fontWeight: "600",
            fontFamily:
              "'LINGTEASUBUN-BOLD', -apple-system, BlinkMacSystemFont, sans-serif",
          }}
        >
          회원가입 인증
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {!loading && (
            <span
              style={{
                fontSize: "14px",
                color: "#6b7280",
                fontWeight: "500",
              }}
            >
              {countdown}초 뒤에 자동 새로고침
            </span>
          )}
          <button
            onClick={fetchWaitingMembers}
            disabled={loading}
            style={{
              padding: "4px 6px",
              backgroundColor: "#4A90E2",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: "14px",
              fontWeight: "700",
              opacity: loading ? 0.7 : 1,
            }}
          >
            <img src="/refresh.png" alt="새로고침" width="22" height="22" />
          </button>
        </div>
      </div>

      {loading && waitingMembers.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #4A90E2",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          ></div>
          <p style={{ color: "#666" }}>데이터를 불러오는 중...</p>
        </div>
      ) : waitingMembers.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#666",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "20px" }}>📭</div>
          <h3>대기 중인 회원이 없습니다</h3>
          <p>새로운 회원가입 신청이 있으면 여기에 표시됩니다.</p>
        </div>
      ) : (
        <div
          style={{
            overflowX: "auto",
            maxWidth: "100%",
          }}
        >
          <table
            style={{
              width: "100%",
              maxWidth: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f8fafc" }}>
                <th style={tableHeaderStyle}>등급</th>
                <th style={tableHeaderStyle}>아이디</th>
                <th style={tableHeaderStyle}>사업자번호</th>
                <th style={tableHeaderStyle}>대표자명</th>
                <th style={tableHeaderStyle}>담당자명</th>
                <th style={tableHeaderStyle}>가입일</th>
                <th style={tableHeaderStyle}>이메일</th>
                <th style={tableHeaderStyle}>연락처</th>
                <th style={tableHeaderStyle}></th>
              </tr>
            </thead>
            <tbody>
              {waitingMembers.map((member, index) => (
                <tr
                  key={member.member_id}
                  onClick={() => {
                    setSelectedMember(member);
                    setShowModal(true);
                  }}
                  style={{
                    borderBottom: "1px solid #e2e8f0",
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f0f9ff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      index % 2 === 0 ? "#ffffff" : "#f8fafc";
                  }}
                >
                  <td style={tableCellStyle}>
                    <span
                      style={{
                        background: "#4A90E2",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "13px",
                        fontWeight: "700",
                      }}
                    >
                      {member.group}
                    </span>
                  </td>
                  <td style={tableCellStyle}>{member.member_id}</td>
                  <td style={tableCellStyle}>
                    {member.business_number.replace(
                      /(\d{3})(\d{2})(\d{5})/,
                      "$1-$2-$3"
                    )}
                  </td>
                  <td style={tableCellStyle}>{member.ceo_name}</td>
                  <td style={tableCellStyle}>{member.manager_name}</td>
                  <td style={tableCellStyle}>
                    {formatDate(member.created_date)}
                  </td>
                  <td style={tableCellStyle}>{member.email || "-"}</td>
                  <td style={tableCellStyle}>
                    {formatPhoneNumber(member.phone) || "-"}
                  </td>
                  <td
                    style={{
                      ...tableCellStyle,
                      backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                    }}
                  ></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MemberAuthTab;
